import React, { useEffect, useMemo, useState } from 'react';
import { NewsletterSignup } from '../../components/NewsletterSignup';
import { SocialShare } from '../../components/SocialShare';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Star } from 'lucide-react';
// --- DATA --------------------------------------------------------------
const CATEGORIES = [{
  id: 'general',
  label: 'General AI Advisors'
}, {
  id: 'shopping',
  label: 'Shopping-Focused AI'
}, {
  id: 'fashion',
  label: 'Fashion & Styling'
}, {
  id: 'beauty',
  label: 'Beauty & Skincare'
}, {
  id: 'home',
  label: 'Home, Furniture & Decor'
}, {
  id: 'grocery',
  label: 'Groceries & Meal Planning'
}, {
  id: 'experts',
  label: 'Human Experts'
}, {
  id: 'travel',
  label: 'Travel & Hospitality'
}, {
  id: 'research',
  label: 'Research & Reviews'
}];
const CHANNELS = [{
  id: 'chat',
  label: 'Chat'
}, {
  id: 'website',
  label: 'Website'
}, {
  id: 'browser',
  label: 'Browser Extension'
}];
const ITEMS = [
// General AI Advisors
{
  id: 'chatgpt',
  name: 'ChatGPT',
  by: 'OpenAI',
  desc: 'Multi-category shopping & research buddy. Ask anything: "Best 55" TV for bright room under $800", "Help me pick a winter coat". New shopping features with Instant Checkout from Etsy/Shopify merchants.',
  url: 'https://chatgpt.com',
  cat: 'general',
  channel: 'chat',
  rating: 4.9,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}, {
  id: 'perplexity',
  name: 'Perplexity AI',
  by: 'Perplexity',
  desc: 'AI answer engine that shops with you. Conversational search with citations, shopping mode with real-time product data, and in-app shopping + PayPal Instant Buy. Great for electronics, fashion, gadgets, gifts.',
  url: 'https://www.perplexity.ai',
  cat: 'general',
  channel: 'chat',
  rating: 4.8,
  conversations: '500K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'google-gemini',
  name: 'Google Gemini',
  by: 'Google',
  desc: 'AI that finds products & shows where to buy. Brainstorm gift ideas and get actual product suggestions with links and comparison tables. Good for gifts, fashion, home, electronics.',
  url: 'https://gemini.google.com',
  cat: 'general',
  channel: 'chat',
  rating: 4.7,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}, {
  id: 'le-chat',
  name: 'Le Chat by Mistral',
  by: 'Mistral AI',
  desc: 'Lightweight, fast research assistant. Multilingual AI chat for product research, comparisons, pros/cons lists. Ask "what should I look for in a gaming monitor vs office monitor."',
  url: 'https://chat.mistral.ai/chat',
  cat: 'general',
  channel: 'chat',
  rating: 4.6,
  conversations: '100K+',
  lastUpdated: '2025-01-01'
},
// Shopping-Focused AI (ChatGPT GPTs)
{
  id: 'shopping-gpt-awesomegpts',
  name: 'Shopping GPT',
  by: 'awesomegpts.ai',
  desc: 'Shop Smarter, Save Bigger! Quickly find top-rated gems and the best deals in the shopping sea!',
  url: 'https://chatgpt.com/g/g-nleealfRT-shopping-gpt',
  cat: 'shopping',
  channel: 'chat',
  rating: 3.5,
  conversations: '50K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'shopping-assistant-madhu',
  name: 'Shopping Assistant',
  by: 'madhu r',
  desc: 'A helpful shopping assistant for finding and comparing products.',
  url: 'https://chatgpt.com/g/g-JquynUdeg-shopping-assistant',
  cat: 'shopping',
  channel: 'chat',
  rating: 4.0,
  conversations: '1K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'ai-coupon-finder',
  name: 'AI Coupon Code Finder: Smart Shopping Companion',
  by: 'community builder',
  desc: "Efficiently find the best online deals with our AI Coupon Finder. Quick, user-friendly, and updated in real-time, it's the ideal tool for savvy shoppers looking to save big effortlessly.",
  url: 'https://chatgpt.com/g/g-23B7QDQzF-ai-coupon-code-finder-smart-shopping-companion',
  cat: 'shopping',
  channel: 'chat',
  rating: 3.0,
  conversations: '5K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'shop-buy-ai',
  name: 'Shop Buy AI - Online Shopping',
  by: 'shopbetterbyai.com',
  desc: 'Your custom shopping assistant - powered by ChatGPT',
  url: 'https://chatgpt.com/g/g-FX1YkCfDi-shop-buy-ai-online-shopping',
  cat: 'shopping',
  channel: 'chat',
  rating: 3.7,
  conversations: '25K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'product-hunter',
  name: 'Online Shopping: Product Hunter',
  by: 'producthunterai.com',
  desc: 'Gift shopping Online, Amazon and more! Compare features, products, pricing, and more!',
  url: 'https://chatgpt.com/g/g-674a6a4bfd9c819196ee6a2a465affbf-online-shopping-product-hunter',
  cat: 'shopping',
  channel: 'chat',
  rating: 3.8,
  conversations: '1K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'shopping-buddy',
  name: 'Shopping Buddy',
  by: 'talkingcart.com',
  desc: "I help you find products on Amazon In the USA and Canada. If you're in Canada, let me know so I search amazon.ca",
  url: 'https://chatgpt.com/g/g-0LCaXfcXj-shopping-buddy',
  cat: 'shopping',
  channel: 'chat',
  rating: 4.0,
  conversations: '1K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'agentic-shopping',
  name: 'Agentic Shopping - Compare Prices & Instant Checkout',
  by: 'ChatGPT',
  desc: 'Compare prices and checkout instantly with agentic shopping assistant.',
  url: 'https://chatgpt.com/g/g-68db40c755548191a974f8aee7c8f5c8-agentic-shopping-compare-prices-instant-checkout',
  cat: 'shopping',
  channel: 'chat',
  rating: 4.0,
  conversations: '5K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'shopping-gpt-brambles',
  name: 'Shopping GPT - Compare Prices and Deals',
  by: 'brambles.ai',
  desc: 'Amazon shopping assistant that provides direct links to products via api. Receive personalized Amazon clickable product links instantly.',
  url: 'https://chatgpt.com/g/g-475one5Sc-shopping-gpt-compare-prices-and-deals',
  cat: 'shopping',
  channel: 'chat',
  rating: 3.2,
  conversations: '1K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'smart-shopping-researcher',
  name: 'Smart Shopping Researcher',
  by: 'Silvina Brodersohn',
  desc: 'A shopping advisor that researches, compares, reviews, finds best prices, tracks deals, and advises when to buy.',
  url: 'https://chatgpt.com/g/g-68c0ea5c32a481918013d3540e5569ac-smart-shopping-researcher',
  cat: 'shopping',
  channel: 'chat',
  rating: 4.0,
  conversations: '60+',
  lastUpdated: '2025-01-02'
}, {
  id: 'klarna-assistant',
  name: 'Klarna AI Assistant',
  by: 'Klarna',
  desc: 'Shopping + payments + deal finder. Chat-based assistant that finds products at the right price across stores. Browser extension auto-applies coupons at 20,000+ stores.',
  url: 'https://www.klarna.com/us/browser-extension/',
  cat: 'shopping',
  channel: 'browser',
  rating: 4.8,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}, {
  id: 'amazon-rufus',
  name: 'Amazon Rufus',
  by: 'Amazon',
  desc: 'AI advisor inside Amazon. Ask open questions like "good laptop for video editing under $1,000" and Rufus explains features, compares options, and shows relevant products.',
  url: 'https://www.amazon.com',
  cat: 'shopping',
  channel: 'website',
  rating: 4.7,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
},
// Fashion & Styling
{
  id: 'fashion-assistant-orbixai',
  name: 'Fashion Assistant | Outfit | Shopping | Budget',
  by: 'orbixai.com',
  desc: 'Upload a photo or provide a description & get fashion tips. Personalized Style Recommendations, Celebrity Style Matching, Smart Savings, Event Outfit Planning, Color Palette Suggestions, Sustainable Fashion Options & more!',
  url: 'https://chatgpt.com/g/g-GOxEy4j5K-fashion-assistant-outfit-shopping-budget',
  cat: 'fashion',
  channel: 'chat',
  rating: 4.1,
  conversations: '100K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'levis-ai-stylist',
  name: "Levi's AI Stylist",
  by: 'Levi Strauss & Co',
  desc: 'Outfitting + AI chatbot. "Complete the Look" shows full outfits around items you view. AI stylist gives personalized outfit recommendations and gets smarter as you browse.',
  url: 'https://www.levistrauss.com/2025/11/17/levis-ai-outfitting/',
  cat: 'fashion',
  channel: 'website',
  rating: 4.7,
  conversations: '50K+',
  lastUpdated: '2025-01-01'
}, {
  id: 'nordstrom-styling',
  name: 'Nordstrom Digital Styling',
  by: 'Nordstrom',
  desc: 'Human expert styling. Answer style quiz for curated outfit recommendations. Virtual or in-store 1:1 sessions with real stylists for fit & style advice, outfits for events.',
  url: 'https://www.nordstrom.com/browse/services/personal-stylists',
  cat: 'fashion',
  channel: 'website',
  rating: 4.8,
  conversations: '100K+',
  lastUpdated: '2025-01-01'
}, {
  id: 'fashion-finder',
  name: 'Fashion Finder',
  by: 'Zhe Li',
  desc: 'Find & buy clothes by description or picture.',
  url: 'https://chatgpt.com/g/g-ZWrizXbhH-fashion-finder',
  cat: 'fashion',
  channel: 'chat',
  rating: 4.6,
  conversations: '10K+',
  lastUpdated: '2024-12-30'
},
// Beauty & Skincare
{
  id: 'beauty-buy-ai',
  name: 'Beauty Buy AI',
  by: 'shopbetterbyai.com',
  desc: 'Premium beauty insights & product recommendations.',
  url: 'https://chatgpt.com/g/g-R1w7HPJbY-beauty-buy-ai-luxury-beauty-shopping',
  cat: 'beauty',
  channel: 'chat',
  rating: 4.7,
  conversations: '5K+',
  lastUpdated: '2024-12-25'
}, {
  id: 'beauty-overlord',
  name: 'The Ultimate Beauty Overlord',
  by: 'Morgan Hipps',
  desc: 'Ask about products & reviews from Sephora & Ulta.',
  url: 'https://chatgpt.com/g/g-r2JcR1GSn-the-ultimate-beauty-overlord',
  cat: 'beauty',
  channel: 'chat',
  rating: 4.6,
  conversations: '1K+',
  lastUpdated: '2024-12-25'
},
// Home, Furniture & Decor
{
  id: 'ikea-assistant',
  name: 'IKEA Assistant',
  by: 'Community',
  desc: 'Explore IKEA products, check availability & get inspiration.',
  url: 'https://chatgpt.com/g/g-4DZ3fQDVL-ikea',
  cat: 'home',
  channel: 'chat',
  rating: 4.6,
  conversations: '5K+',
  lastUpdated: '2024-12-25'
}, {
  id: 'smart-tvs-guide',
  name: 'Smart TVs & 4K TVs Guide',
  by: 'meta-mind.de',
  desc: 'Compare TVs, streaming sticks, speakers & accessories.',
  url: 'https://chatgpt.com/g/g-qwhWsZGfv-smart-tvs-4k-tvs-shopping-guide',
  cat: 'home',
  channel: 'chat',
  rating: 4.7,
  conversations: '5K+',
  lastUpdated: '2024-12-25'
},
// Groceries
{
  id: 'grocery-aigen',
  name: 'Grocery Assistant',
  by: 'ai-gen.co',
  desc: 'Grocery shopping assistant with meal planning & recipes.',
  url: 'https://chatgpt.com/g/g-JMtqHNNLn-grocery',
  cat: 'grocery',
  channel: 'chat',
  rating: 4.6,
  conversations: '5K+',
  lastUpdated: '2024-12-25'
}, {
  id: 'groceriesgpt',
  name: 'GroceriesGPT',
  by: 'Ulysse Rajim',
  desc: 'Manage grocery lists from text, receipts, and photos.',
  url: 'https://chatgpt.com/g/g-FCINlsXdK-groceriesgpt',
  cat: 'grocery',
  channel: 'chat',
  rating: 4.7,
  conversations: '10K+',
  lastUpdated: '2024-12-25'
},
// Human Experts
{
  id: 'curated-experts',
  name: 'Curated',
  by: 'Curated',
  desc: 'Human experts for gear (sports, outdoors, electronics). Fill in what you need (skis, bike, golf clubs, espresso machines) and get matched with a human expert who chats, recommends items, and explains why.',
  url: 'https://www.curated.com',
  cat: 'experts',
  channel: 'website',
  rating: 4.9,
  conversations: '100K+',
  lastUpdated: '2025-01-01'
}, {
  id: 'bestbuy-expert',
  name: 'Best Buy Expert',
  by: 'Best Buy',
  desc: 'Free live chat or video call with tech experts for personalized advice on electronics and appliances.',
  url: 'https://www.bestbuy.com/site/electronics/expert-service/pcmcat1528819595254.c',
  cat: 'experts',
  channel: 'website',
  rating: 4.7,
  conversations: '50K+',
  lastUpdated: '2024-12-28'
},
// Research & Review Sites
{
  id: 'toms-guide',
  name: "Tom's Guide",
  by: "Tom's Guide",
  desc: 'User-friendly guides, practical advice, and "best picks" recommendations for general consumers of technology products.',
  url: 'https://www.tomsguide.com/',
  cat: 'research',
  channel: 'website',
  rating: 4.8,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}, {
  id: 'techradar',
  name: 'TechRadar',
  by: 'TechRadar',
  desc: 'In-depth reviews, detailed analysis, and a broad range of tech news for tech enthusiasts.',
  url: 'https://www.techradar.com/',
  cat: 'research',
  channel: 'website',
  rating: 4.7,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}, {
  id: 'consumer-reports',
  name: 'Consumer Reports',
  by: 'Consumer Reports',
  desc: 'Non-profit organization that provides unbiased product ratings and reviews based on rigorous in-house testing, with no advertising.',
  url: 'https://www.consumerreports.org/',
  cat: 'research',
  channel: 'website',
  rating: 4.9,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}, {
  id: 'wirecutter',
  name: 'Wirecutter',
  by: 'The New York Times',
  desc: 'Conducts extensive research and testing to recommend the single best product in various categories.',
  url: 'https://www.nytimes.com/wirecutter/',
  cat: 'research',
  channel: 'website',
  rating: 4.8,
  conversations: '500K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'cnet',
  name: 'CNET',
  by: 'CNET',
  desc: 'Leading source for news, reviews, and buying guides primarily focused on consumer electronics and technology products.',
  url: 'https://www.cnet.com/',
  cat: 'research',
  channel: 'website',
  rating: 4.7,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}, {
  id: 'rtings',
  name: 'RTings.com',
  by: 'RTings',
  desc: 'Highly detailed, objective, and scientific testing for A/V equipment like TVs, headphones, and monitors.',
  url: 'https://www.rtings.com',
  cat: 'research',
  channel: 'website',
  rating: 4.9,
  conversations: '500K+',
  lastUpdated: '2025-01-02'
}, {
  id: 'trustpilot',
  name: 'Trustpilot',
  by: 'Trustpilot',
  desc: 'Global, third-party review platform where users review companies and their products to build brand trust and transparency.',
  url: 'https://www.trustpilot.com/',
  cat: 'research',
  channel: 'website',
  rating: 4.6,
  conversations: '1M+',
  lastUpdated: '2025-01-02'
}];
// --- UI ---------------------------------------------------------------
export default function GPTStoreShoppingIndex() {
  const [q, setQ] = useState('');
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [activeChannel, setActiveChannel] = useState<string | null>(null);
  const [copiedId, setCopiedId] = useState<string | null>(null);
  useEffect(() => {
    document.title = 'AI Shopping Expert | 100+ AI Shopping Assistants Directory';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Discover 100+ AI shopping assistants and expert advisors across 20+ categories. Find the perfect AI tool for fashion, electronics, travel, groceries, and more. Updated daily.');
    }
  }, []);
  const filtered = useMemo(() => {
    const query = q.trim().toLowerCase();
    return ITEMS.filter(it => {
      const inCat = activeCategory ? it.cat === activeCategory : true;
      const inChannel = activeChannel ? it.channel === activeChannel : true;
      const inQuery = !query ? true : [it.name, it.by, it.desc].some(v => v.toLowerCase().includes(query));
      return inCat && inChannel && inQuery;
    }).sort((a, b) => a.name.localeCompare(b.name));
  }, [q, activeCategory, activeChannel]);
  const counts = useMemo(() => {
    const c: Record<string, number> = {};
    for (const {
      cat
    } of ITEMS) c[cat] = (c[cat] || 0) + 1;
    return c;
  }, []);
  const channelCounts = useMemo(() => {
    const c: Record<string, number> = {};
    for (const {
      channel
    } of ITEMS) c[channel] = (c[channel] || 0) + 1;
    return c;
  }, []);
  useEffect(() => {
    if (!copiedId) return;
    const t = setTimeout(() => setCopiedId(null), 1400);
    return () => clearTimeout(t);
  }, [copiedId]);
  return <div className="min-h-screen bg-slate-50 text-slate-900" data-id="element-859">
      <header className="sticky top-0 z-10 backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/90 border-b border-slate-200" data-id="element-860">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-4 flex items-center justify-between" data-id="element-861">
          <div className="flex items-center gap-3" data-id="element-862">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4yJ3FscyPfrN1xAm7crLNW/ChatGPT_Image_Dec_2%2C_2025%2C_10_42_07_PM.png" alt="Shopping Expert.ai Logo" className="h-12 object-contain" data-id="element-863" />
            <div data-id="element-864">
              <h1 className="text-xl font-bold leading-tight" data-id="element-865">
                AI Shopping Expert
              </h1>
              <p className="text-xs text-slate-500" data-id="element-866">
                100+ AI experts across 9 categories • Updated daily
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-867">
            <SocialShare data-id="element-868" />
            <nav className="hidden md:flex items-center gap-4 text-sm" data-id="element-869">
              <a href="/" className="text-slate-900 font-semibold" data-id="element-870">
                Home
              </a>
              <a href="/most-popular-ai-shopping-assistants" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-871">
                Most Popular
              </a>
              <a href="/productivity-tools" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-872">
                Productivity Tools
              </a>
              <a href="/shopping-tools" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-873">
                Shopping Tools
              </a>
              <a href="/research" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-874">
                Research
              </a>
              <a href="/about" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-875">
                About
              </a>
            </nav>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 sm:px-6 py-8" data-id="element-876">
        {/* Trust Header */}
        <div className="text-center mb-8" data-id="element-877">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2" data-id="element-878">
            Trusted by Shoppers. Chosen by Experts.
          </h2>
          <p className="text-lg text-slate-600 mb-6" data-id="element-879">
            Verified AI Agents You Can Rely On.
          </p>

          {/* Rating Strip */}
          <div className="inline-flex flex-col sm:flex-row items-center justify-center gap-4 p-4 rounded-xl bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 mb-8" data-id="element-880">
            <div className="flex items-center gap-2" data-id="element-881">
              <div className="flex" data-id="element-882">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} size={20} className="fill-green-600 text-green-600" data-id="element-883" />)}
              </div>
              <span className="text-lg font-bold text-green-900" data-id="element-884">4.9/5</span>
            </div>
            <span className="text-slate-600 text-sm" data-id="element-885">
              based on early expert reviews
            </span>
            <div className="hidden sm:block w-px h-6 bg-slate-300" data-id="element-886" />
            <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-slate-700 font-medium" data-id="element-887">
              <span className="flex items-center gap-1" data-id="element-888">
                <span className="w-2 h-2 rounded-full bg-green-600" data-id="element-889" />
                Verified AI Agents
              </span>
              <span className="flex items-center gap-1" data-id="element-890">
                <span className="w-2 h-2 rounded-full bg-blue-600" data-id="element-891" />
                Independent Evaluations
              </span>
              <span className="flex items-center gap-1" data-id="element-892">
                <span className="w-2 h-2 rounded-full bg-purple-600" data-id="element-893" />
                Weekly Updates
              </span>
            </div>
          </div>
        </div>

        {/* Search Box */}
        <div className="mb-6" data-id="element-894">
          <input type="text" placeholder="Search expert advisors, categories, specialists…" value={q} onChange={e => setQ(e.target.value)} className="w-full rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm shadow-sm outline-none focus:ring-2 focus:ring-slate-300" data-id="element-895" />
        </div>

        {/* Category Pills */}
        <div className="mb-4" data-id="element-896">
          <p className="text-sm font-semibold text-slate-700 mb-2" data-id="element-897">
            Categories:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-898">
            <FilterPill label="All Categories" active={!activeCategory} onClick={() => setActiveCategory(null)} data-id="element-899" />
            {CATEGORIES.map(c => <FilterPill key={c.id} label={`${c.label} (${counts[c.id] || 0})`} active={activeCategory === c.id} onClick={() => setActiveCategory(c.id)} data-id="element-900" />)}
          </div>
        </div>

        {/* Channel Pills */}
        <div className="mb-8" data-id="element-901">
          <p className="text-sm font-semibold text-slate-700 mb-2" data-id="element-902">Channel:</p>
          <div className="flex flex-wrap gap-2" data-id="element-903">
            <FilterPill label="All Channels" active={!activeChannel} onClick={() => setActiveChannel(null)} data-id="element-904" />
            {CHANNELS.map(ch => <FilterPill key={ch.id} label={`${ch.label} (${channelCounts[ch.id] || 0})`} active={activeChannel === ch.id} onClick={() => setActiveChannel(ch.id)} data-id="element-905" />)}
          </div>
        </div>

        {/* Grid */}
        {filtered.length === 0 ? <EmptyState query={q} data-id="element-906" /> : <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mb-12" data-id="element-907">
            {filtered.map(it => <Card key={it.id} item={it} onCopy={id => setCopiedId(id)} copied={copiedId === it.id} data-id="element-908" />)}
          </div>}

        <div className="mt-10 text-xs text-slate-500 space-y-2" data-id="element-909">
          <p data-id="element-910">
            Disclaimer: This is a curated directory of AI expert advisors. Links
            may require accounts. Availability may vary.
          </p>
          <p data-id="element-911">
            Want to suggest an expert advisor?{' '}
            <a className="underline" href="/contact" data-id="element-912">
              Contact us
            </a>
          </p>
        </div>
      </main>

      {/* Community-Powered Directory - Above Footer */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 mb-8" data-id="element-913">
        <div className="p-6 rounded-2xl bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-200" data-id="element-914">
          <h3 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-915">
            Community-Powered Directory
          </h3>
          <p className="text-slate-700 mb-4 text-center text-sm" data-id="element-916">
            We grow the directory with real submissions from shoppers, AI
            builders, retail professionals, and creators.
          </p>
          <div className="text-center" data-id="element-917">
            <p className="text-slate-700 mb-3 text-sm" data-id="element-918">
              Know an AI sales advisor we should add?
            </p>
            <a href="mailto:info@shopilots.com" className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white rounded-xl font-semibold hover:bg-black transition-colors text-sm" data-id="element-919">
              Send it to: info@shopilots.com
            </a>
          </div>
        </div>
      </div>

      <footer className="mt-8 border-t border-slate-200" data-id="element-920">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-6" data-id="element-921">
          {/* Our Review Method */}
          <div className="mb-8 p-6 rounded-2xl bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200" data-id="element-922">
            <h3 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-923">
              Our Review Method
            </h3>
            <p className="text-sm text-slate-700 mb-4 text-center" data-id="element-924">
              How We Evaluate AI Agents
            </p>
            <p className="text-sm text-slate-700 mb-4 text-center" data-id="element-925">
              Every agent on ShoppingExpert.ai passes a strict, Trustpilot-style
              review:
            </p>
            <div className="flex flex-wrap justify-center gap-2 mb-4" data-id="element-926">
              {['Accuracy of recommendations', 'Transparency & reliability', 'Real product knowledge', 'Consistency across categories', 'User satisfaction signals'].map((item, idx) => <span key={idx} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white border border-blue-200 text-slate-700 text-xs font-medium" data-id="element-927">
                  <span className="text-green-600 font-bold" data-id="element-928">✓</span>
                  {item}
                </span>)}
            </div>
            <p className="text-sm text-slate-900 font-bold text-center" data-id="element-929">
              If it doesn't meet our standard — it doesn't get listed.
            </p>
          </div>

          <div className="text-center mb-4" data-id="element-930">
            <p className="text-sm font-semibold text-slate-900 mb-1" data-id="element-931">
              ShoppingExpert.ai
            </p>
            <p className="text-xs text-slate-600" data-id="element-932">
              The independent directory of AI Shopping Agents & Sales Advisors.
            </p>
            <p className="text-xs text-slate-600" data-id="element-933">
              Updated weekly. Curated by ShoPilots.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500" data-id="element-934">
            <div data-id="element-935">© 2025 ShoppingExpert.ai • All rights reserved</div>
            <div className="flex items-center gap-3" data-id="element-936">
              <a className="underline" href="/about" data-id="element-937">
                About
              </a>
              <a className="underline" href="/faq" data-id="element-938">
                FAQ
              </a>
              <a className="underline" href="/contact" data-id="element-939">
                Contact
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}
function FilterPill({
  label,
  active,
  onClick
}: {
  label: string;
  active?: boolean;
  onClick?: () => void;
}) {
  return <button onClick={onClick} className={['rounded-full px-3 py-2 text-xs border transition-colors', active ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-700 border-slate-300 hover:border-slate-400'].join(' ')} data-id="element-940">
      {label}
    </button>;
}
function Card({
  item,
  onCopy,
  copied
}: {
  item: any;
  onCopy: (id: string) => void;
  copied: boolean;
}) {
  const channelBadge = {
    chat: '💬 Chat',
    website: '🌐 Website',
    browser: '🔌 Extension'
  }[item.channel] || item.channel;
  return <div className="rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow p-4 flex flex-col gap-3" data-id="element-941">
      <div className="flex items-start justify-between gap-3" data-id="element-942">
        <div data-id="element-943">
          <h3 className="font-semibold leading-snug" data-id="element-944">{item.name}</h3>
          <p className="text-xs text-slate-500" data-id="element-945">by {item.by}</p>
        </div>
        <span className="inline-flex items-center text-[10px] px-2 py-1 rounded-full bg-slate-100 text-slate-700 border border-slate-200" data-id="element-946">
          {badgeLabel(item.cat)}
        </span>
      </div>

      <div className="flex items-center gap-2" data-id="element-947">
        <span className="text-xs px-2 py-1 rounded-full bg-blue-50 text-blue-700 border border-blue-200" data-id="element-948">
          {channelBadge}
        </span>
        {item.rating && <span className="text-xs text-slate-600" data-id="element-949">⭐ {item.rating}</span>}
        {item.conversations && <span className="text-xs text-slate-500" data-id="element-950">{item.conversations}</span>}
      </div>

      <p className="text-sm text-slate-700 line-clamp-3" data-id="element-951">{item.desc}</p>

      {item.lastUpdated && <p className="text-xs text-slate-500" data-id="element-952">
          Updated:{' '}
          {new Date(item.lastUpdated).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })}
        </p>}

      <div className="mt-1 flex items-center gap-2" data-id="element-953">
        <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-sm inline-flex items-center justify-center rounded-xl px-3 py-2 bg-slate-900 text-white hover:bg-black transition-colors" data-id="element-954">
          Open Tool ↗
        </a>
        <button onClick={async () => {
        try {
          await navigator.clipboard.writeText(item.url);
          onCopy(item.id);
        } catch (e) {
          onCopy('');
        }
      }} className="text-sm inline-flex items-center justify-center rounded-xl px-3 py-2 border border-slate-300 hover:bg-slate-50 transition-colors" data-id="element-955">
          {copied ? 'Copied!' : 'Copy link'}
        </button>
      </div>
    </div>;
}
function badgeLabel(cat: string) {
  const map: Record<string, string> = Object.fromEntries(CATEGORIES.map(c => [c.id, c.label]));
  return map[cat] || cat;
}
function EmptyState({
  query
}: {
  query: string;
}) {
  return <div className="flex flex-col items-center justify-center text-center py-20" data-id="element-956">
      <div className="h-16 w-16 rounded-2xl bg-slate-200 grid place-items-center text-slate-600 text-xl" data-id="element-957">
        🤔
      </div>
      <h4 className="mt-4 text-lg font-semibold" data-id="element-958">No matches found</h4>
      <p className="text-sm text-slate-600 mt-1" data-id="element-959">
        Try a different search term, or pick another category. (You searched for
        "{query}".)
      </p>
    </div>;
}